<template>
  <div class="app-container">
    <div class="filter-container flex">
      <el-button type="primary" @click="handleCreate">新增</el-button>
      <div>
        <el-select v-model="listQuery.state" placeholder="状态" style="width: 200px; margin-right: 10px;" type="primary"
          clearable>
          <el-option label="正常" :value="1" />
          <el-option label="已下架" :value="0" />
        </el-select>
        <el-button type="primary" @click="handleFilter">搜索</el-button>
      </div>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.state === 0" type="warning">已下架</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="创建时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.state === 1" type="warning" size="mini"
            @click="handleForbid(scope.row.id, '下架')">下架</el-button>
          <el-button v-else size="mini" type="primary" @click="handleForbid(scope.row.id, '上架')">上架</el-button>

          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>


    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="60%">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="70px"
        style="width: 88%; margin-left:50px;">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>

        <el-form-item label="详情" prop="content">
          <label>编辑文章</label>
          <tinymce ref="tinymce" style="width:100%;" :height="300" v-model="form.content" :value="form.content" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { articleList } from "@/api/basic"
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import Tinymce from '@/components/Tinymce'


export default {
  components: {
    "img-crop-upload": imgCropUpload, Tinymce,
    uploadList
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        state: null
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      form: {
        id: "",
        title: "",
        content: "",
      },
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        content: [{ required: true, message: "标题不能为空", trigger: "blur" }]
      },
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      articleList(this.listQuery).then(({ data }) => {
        this.list = data.data;
        this.total = data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(limit) {
      this.listQuery.limit = limit;
      this.getList();
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        title: "",
        content: "",
        sort: "",
      };
      this.btnLoading = false;
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      if (this.$refs.tinymce) this.$refs.tinymce.setContent('')
      this.$nextTick(() => {
        this.$refs['form'].clearValidate() //清除校验结果
      })
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row); // copy obj
      this.form.type = Number(this.form.type)
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      console.log(this.form, this.form.imgArray);
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/basics/article/add", // category_id:{1.首页轮播图}
            method: "post",
            data: this.form
          })
            .then(() => {
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/basics/article/state",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => { });
    },

    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/basics/article/del",
            method: "post",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
  }
};
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.upload-one-component .upload-one-component-image {
  width: auto;
  height: 200px;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
